import React from "react";
import PropTypes from "prop-types";

import { CN_ICON_VIEW } from "./IconView.constants";

const IconView = (props) => {
  const { icon, className, children, ...restProps } = props;

  if (!icon) {
    return null;
  }

  if (typeof icon === "number") {
    if (restProps.fill) {
      restProps.style = { color: restProps.fill };
    }

    return (
      <i {...restProps} className={(className || "") + " " + CN_ICON_VIEW}>
        {String.fromCodePoint(icon)}
        {children}
      </i>
    );
  }

  const Icon = icon;
  return <Icon {...restProps} className={"icon-base " + (className || "")} />;
};

IconView.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
};

export default IconView;
